<template>
  <div>
    <b-container>
      <b-card-group columns>
        <b-card :title="'Payments'" class="mb-2 min-card-size">
          <hr />
          <div v-if="getVendor.id && !loading && isConnected">
            <StripeConnectButton
              v-if="!getVendor.stripe_id"
            ></StripeConnectButton>
            <div v-else>
              <a
                class="stripe-link"
                target="_blank"
                :href="`https://dashboard.stripe.com/${getVendor.stripe_id}/dashboard`"
                >View Stripe Data</a
              >
            </div>
          </div>
          <div v-if="getVendor.stripe_id" class="stripe-terimanls">
            <h4 class="card-title">Terminals</h4>
            <div v-if="getVendor.id && !loading && isConnected">
              <div v-if="!getVendor.stripe_location_id">
                <div v-if="isLoading">
                  <spinner-loader />
                </div>
                <b-btn v-else @click="initializeTerminalIntegration"
                  >Integrate Readers</b-btn
                >
              </div>
              <div v-else>
                <div class="terminal-status">
                  <b>Terminal Status:</b>
                  <p>{{ connectionMessage }}</p>
                </div>

                <div
                  v-if="getAvailableReaders && getAvailableReaders.length > 0"
                  class="readers-selection"
                >
                  <h5>Readers available:</h5>
                  <div
                    class="readers-list-item"
                    v-for="reader in getAvailableReaders"
                    v-bind:key="reader.id"
                  >
                    <div class="reader-data">
                      <b>label:</b> {{ reader.label }}
                    </div>
                    <div class="reader-data">
                      <b>status:</b> {{ reader.status }}
                    </div>
                    <b-btn
                      :disabled="connectingReader"
                      @click="toggleReaderConnection(reader)"
                      >{{ readerButtonText(reader.id) }}</b-btn
                    >
                  </div>
                </div>

                <b-btn
                  :disabled="connectingReader"
                  @click="registeringReader = true"
                  >Register New Reader</b-btn
                >

                <div v-if="registeringReader">
                  <span
                    >Enter the key sequence <br /><br />
                    <h4>0 7 1 3 9</h4>
                    <br />
                    on the terminal to display your registration code.
                  </span>
                  <br /><br />
                  <b-input v-model="readerLabel" placeholder="Reader Label" />
                  <b-input
                    v-model="registrationCode"
                    placeholder="Registration Code"
                  />
                  <br />
                  <b-button @click="registerReader"> Register </b-button>
                </div>
                <div
                  v-if="!webHookRegistered"
                  class="register-web-hook mt-3 pt-3"
                >
                  <b-btn @click="registerWebHookEndpoint"
                    >Register WebHook Endpoint</b-btn
                  >
                </div>
              </div>
            </div>
            <div v-else>
              <div class="card-loading-blank"></div>
              <spinner-loader />
            </div>
          </div>
        </b-card>

        <!-- <b-card :title="'Channel Manager'" class="mb-2 min-card-size">
          <hr>
          <template v-if="channexStatus === 1">
            <span>Connected!</span>
            <div v-if="!getVendor.channex_subscription_id" class="register-web-hook mt-3 pt-3">
              <b-btn @click="registerChannexWebHookEndpoint">Register WebHook Endpoint</b-btn>
            </div>
          </template>
          <b-button v-else @click="onConnectChannex">Connect Channel Manager</b-button>
        </b-card> -->
      </b-card-group>
    </b-container>
  </div>
</template>

<script>
import StripeConnectButton from "@/components/payments/StripeConnectButton";
import SpinnerLoader from "@/components/widgets/SpinnerLoader";
import ApiBase from "@/utils/api-base";
import API from "@/api";
import cloneDeep from "lodash.clonedeep";

import { mapGetters, mapState, mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "Integrations",
  components: {
    StripeConnectButton,
    SpinnerLoader,
  },
  data() {
    return {
      loading: true,
      terminal: null,
      registeringReader: false,
      registrationCode: "",
      readerLabel: "",
      connectingReader: false,
      webHookUrl: "",
      webHookRegistered: false,
    };
  },
  computed: {
    ...mapGetters([
      "getVendor",
      "isConnected",
      "channexStatus",
      "getAvailableReaders",
      "getCurrentReader",
      "getReaderConnectionStatus",
    ]),
    ...mapState({
      isLoading: (state) => state.terminal.isRequesting,
      terminalExists: (state) => state.terminal.terminalExists,
    }),
    connectionMessage() {
      return `${this.getReaderConnectionStatus} ${
        this.getReaderConnectionStatus === "connected" && this.getCurrentReader
          ? `to ${this.getCurrentReader.label}`
          : ""
      }`;
    },
  },

  async mounted() {
    this.stripeConnectIntegration();
    if (this.terminalExists) {
      this.stripeTerminalIntegration();
    }

    if (process.env.NODE_ENV === "development") {
      this.webHookRegistered = true;
      return;
    }

    this.webHookUrl = `${API.BASE_URL}/webhook/stripe`;

    this.getStripeWebHookEndpoints().then((res) => {
      if (res.data && res.data.length) {
        res.data.map((e) => {
          if (e.url === this.webHookUrl) {
            this.webHookRegistered = true;
          }
        });
      }
    });
  },

  methods: {
    ...mapActions([
      "connectToStripeTerminal",
      "initializeStripeTerminal",
      "verifyStripeConnection",
      "readerDisconnected",
      "initializeStripeTerminal",
      "readerConnected",
      "discoverReaders",
      "connectReader",
      "disconnectReader",
      "initializeTerminalIntegration",
      "registerStripeTerminal",
      "getStripeWebHookEndpoints",
      "createStripeWebHookEndpoint",
      "setShowLoadingOverlay",
    ]),
    async createTerminalLocation() {
      await initializeTerminalIntegration();
    },
    async stripeTerminalIntegration() {
      try {
        this.terminal = await this.connectToStripeTerminal();
      } catch (e) {
        this.errorNotification(e);
      }

      this.initializeStripeTerminal(this.terminal);
      this.connectingReader = true;

      try {
        await this.discoverReaders();
      } catch (e) {
        this.errorNotification(e);
      }

      this.connectingReader = false;
    },

    async stripeConnectIntegration() {
      if (this.$route.query.code) {
        this.loading = true;

        try {
          const res = await this.verifyStripeConnection(this.$route.query.code);
        } catch (e) {
          this.loading = false;
          this.errorNotification(e);
        }

        const newRouteQuery = _.omit(this.$route.query, "code");
        this.$router.replace({
          query: newRouteQuery,
        });
      }

      this.loading = false;
    },
    readerButtonText(readerId) {
      if (!this.getCurrentReader) return "Connect";
      return readerId === this.getCurrentReader.id ? "Disconnect" : "Connect";
    },
    async toggleReaderConnection(reader) {
      if (!this.getCurrentReader || this.getCurrentReader.id !== reader.id) {
        this.infoNotification("connecting terminal...");
        this.connectingReader = true;
        const readerConnection = await this.connectReader(reader);
        this.connectingReader = false;

        if (readerConnection.error) {
          this.errorNotification(
            `Failed to connect: ${readerConnection.error.message}`
          );
        } else {
          this.readerConnected(reader);
          this.infoNotification(
            `Connected to reader: ${readerConnection.reader.label}`
          );
        }
      } else if (this.getCurrentReader.id === reader.id) {
        this.disconnectReader(reader);
      }
    },
    disconnectReader(reader) {
      this.terminal.disconnectReader().then((disconnectResult) => {
        if (disconnectResult.error) {
          this.errorNotification(
            `Failed to disconnect: ${connectResult.error}`
          );
        } else {
          this.readerDisconnected(reader);
          this.infoNotification(`Disconnect from reader: ${reader.label}`);
          this.initializeStripeTerminal(cloneDeep(this.terminal));
        }
      });
    },
    async registerReader() {
      try {
        await this.registerStripeTerminal({
          location: this.getVendor.stripe_location_id,
          label: this.readerLabel,
          registration_code: this.registrationCode,
        });
        this.successNotification(`Register ${this.readerLabel} added.`);
        this.registeringReader = false;
        await this.discoverReaders();
      } catch (error) {
        this.errorNotification(
          "Failed to connect. Please double check registration code."
        );
      }
    },

    registerWebHookEndpoint() {
      this.createStripeWebHookEndpoint({
        url: this.webHookUrl,
        connect: true,
        enabled_events: ["charge.failed", "charge.succeeded"],
      })
        .then((res) => {
          this.webHookRegistered = true;
          this.successNotification(
            "Stripe WebHookEndpoint have successfully registered."
          );
        })
        .catch((err) => {
          this.errorNotification(`Register WebHookEndpoint error: ${err}`);
        });
    },

    connectToChannex() {
      return ApiBase.post(API.CHANNEX_CONNECT)
        .then(() => {
          return this.$store.dispatch("setChannexStatus", 1);
        })
        .catch((err) => {
          this.errorNotification(
            err.message || "Failed to connect to Channel Manager."
          );
        })
        .finally(() => {
          this.setShowLoadingOverlay(false);
        });
    },

    onConnectChannex() {
      this.setShowLoadingOverlay(true);

      if (this.channexStatus !== -2) {
        return this.connectToChannex();
      }

      return ApiBase.post(API.CHANNEX_SIGN_IN)
        .then(() => {
          return this.connectToChannex();
        })
        .catch(() => {
          this.errorNotification(
            err.message || "Failed to connect to Channel Manager."
          );
        });
    },

    registerChannexWebHookEndpoint() {
      const params = {
        url: `${API.BASE_URL}/webhook/channex`,
      };

      this.setShowLoadingOverlay(true);

      return ApiBase.post(API.CHANNEX_SUBSCRIBE, params)
        .then(() => {
          return this.$store.dispatch("getVendorData");
        })
        .catch((err) => {
          this.errorNotification(
            err.message || "Failed to register webhook of channex."
          );
        })
        .finally(() => {
          this.setShowLoadingOverlay(false);
        });
    },
  },
  watch: {
    terminalExists(nowExists, didNotExist) {
      if (!didNotExist && nowExists) {
        this.stripeTerminalIntegration();
      }
    },
  },
};
</script>

<style lang="scss">
.stripe-link {
  color: blue;
}

.stripe-link:hover {
  color: blue;
}

.card-loading-blank {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
}
.stripe-terimanls {
  padding-top: 35px;
  margin-top: 35px;
  border-top: 1px solid black;
}
.readers-list-item {
  padding: 15px 0;
  border-bottom: 1px dotted black;
  border-top: 1px dotted black;
}
.readers-selection {
  margin-bottom: 15px;
}
.register-web-hook {
  border-top: 1px solid #000;
}

.min-card-size {
  min-height: 145px;
}
</style>
